// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "header-1zUP7";
var _4 = "modalPaper-byyEy";
var _5 = "modalTitle-2rPWN";
var _6 = "tabHeader-te4ST";
var _7 = "tabs-33G9U";
var _8 = "indicator-22fMv";
var _9 = "sendTicketsContainer-mt1V3";
var _a = "downloadContainer-2xhpe";
var _b = "buttons-1cWRK";
var _c = "button-2BEgy";
var _d = "select-3oNIs";
var _e = "resend_wrapper-2FSrN";
var _f = "slideUpWrapper-3qa2n";
var _10 = "slideUp-2dfV2";
var _11 = "slideUp__header-1A6P4";
export { _1 as "__esModule", _2 as "mobile", _3 as "header", _4 as "modalPaper", _5 as "modalTitle", _6 as "tabHeader", _7 as "tabs", _8 as "indicator", _9 as "sendTicketsContainer", _a as "downloadContainer", _b as "buttons", _c as "button", _d as "select", _e as "resend_wrapper", _f as "slideUpWrapper", _10 as "slideUp", _11 as "slideUp__header" }
export default { "__esModule": _1, "mobile": _2, "header": _3, "modalPaper": _4, "modalTitle": _5, "tabHeader": _6, "tabs": _7, "indicator": _8, "sendTicketsContainer": _9, "downloadContainer": _a, "buttons": _b, "button": _c, "select": _d, "resend_wrapper": _e, "slideUpWrapper": _f, "slideUp": _10, "slideUp__header": _11 }
